import Typography from '@alltrails/shared/denali/components/Typography';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import Button from '@alltrails/shared/denali/components/Button';
import { wrapUrlSafe } from 'utils/language_support_util';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import * as styles from './OurMission.module.scss';
import mission1256JpgSrc from './mission-1256w.jpg';
import mission1256WebpSrc from './mission-1256w.webp';
import mission1256AvifSrc from './mission-1256w.avif';
import mission736JpgSrc from './mission-736w.jpg';
import mission736WebpSrc from './mission-736w.webp';
import mission736AvifSrc from './mission-736w.avif';
import { MEDIA_QUERY_SMALL_DOWN } from 'utils/constants/breakpoints';

// Desktop: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=2051%3A11145&t=cUpJazhHh3xTYrS1-4
// Mobile: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=2051%3A11299&t=cUpJazhHh3xTYrS1-4
export default function OurMission() {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div>
          <picture>
            <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={mission736AvifSrc} type="image/avif" />
            <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={mission736WebpSrc} type="image/webp" />
            <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={mission736JpgSrc} type="image/jpg" />
            <source srcSet={mission1256AvifSrc} type="image/avif" />
            <source srcSet={mission1256WebpSrc} type="image/webp" />
            <img alt="" className={styles.img} loading="lazy" src={mission1256JpgSrc} />
          </picture>
        </div>
        <div className={styles.mission}>
          <div>
            <Typography color="inverse" component="div" variant="heading600">
              <FormattedMessage defaultMessage="Our mission" />
            </Typography>
            <Typography className={styles.text} color="inverse" component="div" variant="paragraph300">
              <FormattedMessage defaultMessage="AllTrails was founded on the idea that we’re all made better by spending time in nature. Each day, we strive to connect more people to the outdoors." />
            </Typography>
            <Button
              linkInfo={{ href: wrapUrlSafe('/about', languageRegionCode) }}
              testId="learn-more"
              text={<FormattedMessage defaultMessage="Learn more about us" />}
              variant="elevated"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
